
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40.797","height":"33.439"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 11348"}},[_c('path',{attrs:{"data-name":"Path 8345","d":"M36.016 3.061a.612.612 0 00-.61.612v22.043h-3.315a51.844 51.844 0 00-11.667 1.332 1.212 1.212 0 01-1.287-.51 13.847 13.847 0 017.241-2.048h7.2a.611.611 0 00.61-.612V.612a.612.612 0 00-.61-.612H23.563a5.868 5.868 0 00-5.25 3.265A5.866 5.866 0 0013.064 0H3.048a.612.612 0 00-.61.612V23.88a.611.611 0 00.61.612h7.2a13.849 13.849 0 017.239 2.046 1.217 1.217 0 01-1.279.512 51.826 51.826 0 00-11.672-1.333H1.221V3.671a.61.61 0 10-1.221 0v22.656a.611.611 0 00.61.612h3.925a50.65 50.65 0 0111.39 1.3 4.053 4.053 0 014.769 0 50.66 50.66 0 0111.4-1.3h3.925a.611.611 0 00.61-.611V3.671a.612.612 0 00-.613-.61zm-25.768 20.21H3.66V1.225h9.4a4.65 4.65 0 014.64 4.657v19.352a15.069 15.069 0 00-7.452-1.963zm8.674-17.394a4.651 4.651 0 014.639-4.648h9.4V23.271h-6.586a15.069 15.069 0 00-7.453 1.966z","fill":"#464646"}}),_c('g',{attrs:{"data-name":"Group 11294","transform":"translate(-1484.647 -343.152)"}},[_c('circle',{attrs:{"data-name":"Ellipse 614","cx":"9.796","cy":"9.796","r":"9.796","transform":"translate(1505.853 357)","fill":"#464646"}}),_c('g',{attrs:{"data-name":"Group 11285","transform":"translate(1513.989 360.608)","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 8346","d":"M1.55 12.482A1.152 1.152 0 01.398 11.33V5.075A1.152 1.152 0 011.55 3.923a1.152 1.152 0 011.152 1.152v6.255a1.152 1.152 0 01-1.152 1.152z"}}),_c('circle',{attrs:{"data-name":"Ellipse 612","cx":"1.66","cy":"1.66","r":"1.66"}})])])])])
          )
        }
      }
    